import Layout from '@/layout';

export default [
  {
    path: '/doc',
    component: Layout,
    redirect: '/doc/getting-started',
    name: 'doc',
    meta: {
      icon: 'Reading',
      title: '帮助文档',
    },
    children: [
      {
        path: 'getting-started',
        component: () => import('@/views/help-doc/index.vue'),
        name: 'help-doc-getting-started',
        meta: {
          icon: 'HomeFilled',
          title: '快速上手',
        },
      },
      // 新增文档：在 public/doc 下放 <name>.md，然后在这里加一条路由
      // {
      //   path: 'xxx',
      //   component: () => import('@/views/help-doc/index.vue'),
      //   name: 'help-doc-xxx',
      //   meta: { icon: 'Document', title: '标题' },
      // },
    ],
  },
];
